import { Box } from "@outschool/backpack";
import React from "react";

import * as Activity from "../../../../../shared/Activity";
import { ActivityListing_ListingFragment } from "../../../../../shared/generated/graphql";
import * as Routes from "../../../../../shared/Routes";
import { getTrackingObject } from "../../../../routes/TeacherProfile";
import Link from "../../../Link";
import { AgeRange, ClassImage, ClassTime, Title } from "../UpcomingClass";

type UpcomingClassProps = {
  upcomingClass: ActivityListing_ListingFragment;
};

export const UpcomingClass: React.FunctionComponent<UpcomingClassProps> = ({
  upcomingClass
}) => {
  const { activity, nextSection } = upcomingClass;

  const start =
    nextSection?.nextOngoingMeeting?.start_time || nextSection?.start_time;

  const end =
    nextSection?.nextOngoingMeeting?.end_time || nextSection?.end_time;

  const upcomingListingTrackingObject = React.useMemo(
    () =>
      getTrackingObject({
        area: "Upcoming Classes Widget",
        activity: upcomingClass.activity,
        section: upcomingClass?.nextSection,
        leader: upcomingClass.leader
      }),
    [upcomingClass]
  );

  const activityPath = React.useMemo(
    () => Routes.activityPath(activity),
    [activity]
  );

  // here
  return (
    <Link to={activityPath} {...upcomingListingTrackingObject} useLinkTracking>
      <Box
        flex
        sx={{
          paddingY: "16px",
          borderBottom: "1px solid #DDDFE3"
        }}
      >
        <ClassImage photoUrl={activity.details.photo} />

        <Box
          sx={{
            marginLeft: "12px",
            overflow: "hidden"
          }}
        >
          {start && end && (
            <ClassTime
              start={start}
              end={end}
              isFlex={Activity.isFlexSchedule(activity)}
              formatOption="date-and-time"
            />
          )}

          <Title title={activity.title} />

          <AgeRange minAge={activity.age_min} maxAge={activity.age_max} />
        </Box>
      </Box>
    </Link>
  );
};
